import { routerRedux } from 'dva/router';
import { message } from 'antd';
import { doLogout, doLogin, fetchClientId, fetchInfo, proxyReq, loginSelect } from '../services/user';

const deployType = process.env.CONFIG_ENV;
let URL = process.argv.splice(2)[0] || 'dev';
(URL && URL !== 'dev') ? URL = process.argv[process.argv.length - 1].split('--')[1] : ''
console.log("process", URL)
let musicHost = '';
let redirecUrl = '';
if(deployType === 'online'){
  musicHost = '//music.163.com';
  redirecUrl = '//maisui.netease.com/sponsor';
}else if(deployType === 'test'){
  // musicHost = 'http://qa.igame.163.com';
  musicHost = '//qa.igame.163.com';
  redirecUrl = '//iadluck.netease.com/ui/maisui/test/sponsor';
}else if(deployType === 'test-ndp'){
  musicHost = '//qa.igame.163.com';
  redirecUrl = '//iadluck.netease.com/ui/maisui/test/sponsor';
}else if(deployType === 'performance'){
  musicHost = '//qa.igame.163.com';
  redirecUrl = '//iadluck.netease.com/test/maisui/performance/sponsor';
}else if(deployType === 'beta'){
  musicHost = '//qa.igame.163.com';
  redirecUrl = '//iadluck.netease.com/test/maisui/beta/sponsor';
}else if(deployType === 'alpha'){
  musicHost = '//qa.igame.163.com';
  redirecUrl = '//iadluck.netease.com/ui/maisui/alpha/sponsor';
}else if(deployType === 'docker'){
  musicHost = '//qa.igame.163.com';
  redirecUrl = '//iadluck.netease.com/ui/docker/'+ URL +'/adman-gateway/';
}else{
  musicHost = 'http://qa.igame.163.com';
  redirecUrl = 'http://iadluck.netease.com/test/maisui/dev/sponsor';
}

const AUTHRIZA_URL = `${musicHost}/m/oauth2/authorize`;
const REDIRECT_URI = `http:${redirecUrl}/#/accountbind`;

export default {
  namespace: 'user',

  state: {
    fundData: {},
    list: [],
    loading: false,
    currentUser: {
      name: 'weikaiqiang@163.com',
      avatar: 'http://stonenos.nos.netease.com/H7138--1470984891535180446--9429642a8e3f728faa6872c030af9c07.jpg',
      sponsorId: 210000005,
      userId:112112,
      operatorName: 'hzweikaiqiang',
    },
    dynamicNav: {},
    status: undefined,
    userInfo: {},
    musicBindUrl: '',

    sponsorInfo: {},
  },

  effects: {
    *doLogin({ payload }, { call, put }) {
      const response = yield call(doLogin, payload);
      yield put({
        type: 'saveLogin',
        payload: response,
      });
      if(response && response.authStatus === "SUCCESS"){
       if(!response.sponsorId) {
        message.info('账号未开户，请联系管理员');
       }else {
        yield window.location.reload();
       }
      }
    },
    *doLoginSelect({ payload, callback }, { call, put }) {
      const response = yield call(loginSelect, payload);
      callback(response);
    },
    *doLogout({ payload }, { call, put }) {
      const response = yield call(doLogout, payload);
      yield put({
        type: 'saveLogout',
        payload: {
          status: false,
        },
      });
      yield put(routerRedux.push('/user/login'));
    },
    *fetchCurrent(_, { call, put }) {},
    *fetchNav(_, { call, put }) {},

    *fetchClientId(_, { call, put }) {
      const response = yield call(fetchClientId);
      if (response) {
        yield put({
          type: 'saveClientId',
          payload: response,
        });
      }
    },
    *fetchInfo(_, { call, put }) {
      const response = yield call(fetchInfo);
      yield put({
        type: 'saveInfo',
        payload: response,
      });
    },
    *proxyReq({ payload }, { call, put }) {
      const response = yield call(proxyReq, payload);
      console.log('req', response)
      yield put({
        type: 'saveLogin',
        payload: response,
      });
      if (response.authStatus === 'SUCCESS') {
        yield window.location.reload();
      }
    },
  },

  reducers: {
    loadHomeFund(state, { payload }) {
      const fundData = { ...state.fundData, ...payload };
      return {
        ...state,
        fundData,
      };
    },
    saveLogin(state, { payload }) {
      sessionStorage.setItem('isLoginSponsor', !!payload.sponsorId);
      
      if(payload.sponsorId) {
        sessionStorage.setItem('userInfo', JSON.stringify(payload));
      }

      const currentUser = { ...state.currentUser, ...payload}
      return {
        ...state, currentUser,
      };
    },
    saveLogout(state, { payload }) {
      sessionStorage.setItem('isLoginSponsor', false);
      sessionStorage.removeItem('userInfo')
      localStorage.removeItem("loginCondition");
      sessionStorage.removeItem('clientId');
      return {
        ...state,
        submitting: payload,
      };
    },
    save(state, action) {
      return {
        ...state,
        list: action.payload,
      };
    },
    changeLoading(state, action) {
      return {
        ...state,
        loading: action.payload,
      };
    },
    saveCurrentUser(state, action) {
      return {
        ...state,
        currentUser: action.payload,
      };
    },
    saveDynamicNav(state, action) {
      return {
        ...state,
        dynamicNav: action.payload,
      };
    },
    saveClientId(state, { payload }) {
      // sessionStorage.setItem('clientId', payload);
      const url = `${AUTHRIZA_URL}?client_id=${encodeURIComponent(payload.clientId)}&response_type=json&state=${''}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}`
      return {
        ...state,
        musicBindUrl: url,
      }
    },
    
    saveInfo(state, { payload }) {
      const curData = JSON.parse(sessionStorage.getItem('userInfo'));
      sessionStorage.setItem('userInfo', JSON.stringify({...curData, fundAccountName: payload?.fundAccountName}));
      return {
        ...state,
        sponsorInfo: payload || {},
      }
    },
  },
};
